import type { TenantConfig } from "./types";

// libraos — 中性品牌,用于对外演示与测试环境(test-bosong)。
// 2026-08-27 的 demo 曾直接把 bosong 租户改名成 LibraOS,结果那次改动
// 混进了随后的生产构建,博颂的真实用户看到了 LibraOS。品牌切换必须
// 走独立租户 + VITE_TENANT,不能改租户自身的 displayName。
export const libraosTenant: TenantConfig = {
  slug: "libraos",
  displayName: "LibraOS",
  tagline: "Enterprise AI Platform",
  defaultLocale: "zh-CN",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/nova_os_icon_256.svg",
  },
};
